"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipWrapperEditable = exports.InfoWrapper = exports.IconWrapper = exports.EditableTitleWrapper = exports.EditableTitleSubWrapper = exports.SubtitleLabel = exports.TooltipWrapper = exports.Subtitle = exports.ProjectLabelEditBtn = exports.CursorWrapper = exports.ProjectLabelText = exports.ProjectLabel = exports.ProjectLabelContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.ProjectLabelContainer = styled_components_1.default.div `
  display: flex;
  font-weight: ${({ $isBold }) => ($isBold ? 700 : 400)};
`;
exports.ProjectLabel = styled_components_1.default.label `
  display: flex;
  font-size: 14px;
  color: ${colors_1.GREY4};
  align-items: center;

  ${({ $isEditable }) => $isEditable &&
    (0, styled_components_1.css) `
      cursor: pointer;
      &:hover div {
        visibility: visible;
      }
      &:hover ${exports.ProjectLabelText} {
        text-decoration: underline;
      }
    `};
`;
exports.ProjectLabelText = styled_components_1.default.div ``;
exports.CursorWrapper = styled_components_1.default.div `
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
`;
exports.ProjectLabelEditBtn = styled_components_1.default.div `
  visibility: hidden;
  margin-left: 5px;
  cursor: pointer;
`;
exports.Subtitle = styled_components_1.default.div `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${colors_1.GREY3};
`;
exports.TooltipWrapper = styled_components_1.default.div `
  margin: 2px 0 0 3px;
`;
exports.SubtitleLabel = styled_components_1.default.span `
  cursor: pointer;
`;
exports.EditableTitleSubWrapper = styled_components_1.default.div ``;
exports.EditableTitleWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.IconWrapper = styled_components_1.default.div `
  margin-right: 9px;
`;
exports.InfoWrapper = styled_components_1.default.div `
  margin: 6px 0 0 4px;
  cursor: pointer;
`;
exports.TooltipWrapperEditable = styled_components_1.default.div `
  position: relative;
  top: -58px;
  left: 58%;
  transform: translateX(-58%);
`;
//# sourceMappingURL=EditableTitle.styles.js.map